module.exports = __webpack_public_path__ + "static/media/Group 57689.7cb01f41.svg";